import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { GStatic } from '../../services/GStatic';

@Pipe({
  name: 'dateTransform',
})
export class DateTransformPipe implements PipeTransform {
  transform(
    value: any,
    inputFormat: string = 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
    dateOnly: boolean = false,
    dateWithTime: boolean = false,
  ): string {
    let formattedDate = GStatic.defaultDateFormat(value);
    if (formattedDate !== 'Invalid date' && value !== null) {
      const timeZone = moment.tz.guess(); // Get the current time zone of the browser

      const localFormattedDate = moment.utc(formattedDate).tz(timeZone);

      const finalFormattedDate = localFormattedDate['_i'];
      const parts = finalFormattedDate.split(' ');
      const date = parts[0];
      const time = parts[1];
      const lang = localStorage.getItem('lang');
      let ampm = parts[2] || '';
      if (lang === 'ar') {
        ampm = ampm === 'am' ? 'ص' : 'م';
      }
      // Russian uses 24-hour format, no AM/PM suffix
      const timeSuffix = lang === 'ru' || !ampm ? time : time + ' ' + ampm;
      if (!dateOnly && !dateWithTime) {
        return date + ' <small class="whitespace-nowrap">' + timeSuffix + '</small>';
      }
      if (dateOnly) {
        return date;
      }
      if (dateWithTime) {
        return date + ' ' + timeSuffix;
      }
    } else {
      return localStorage.getItem('lang') === 'ar' ? 'غير محدد' : 'N/A';
    }
  }
}
